import jquery from 'jquery';
import htmx from 'htmx.org/dist/htmx.esm.js';

window.$ = window.jQuery = jquery;
window.htmx = htmx;
